import { useLocation } from 'react-router';

import { useHasPermissions } from '~domains/auth';

import { useGetPointsOfSalesQuery } from '~entities/pos';

import { ROUTES } from '~shared/config/routes';

import IconDashboard from '../icons/dashboard.svg?react';
import IconOrders from '../icons/orders.svg?react';
import IconReports from '../icons/reports.svg?react';
import { NavItemProps } from '../types';

export const useNavigationItems = () => {
  const { pathname } = useLocation();
  const { data: posList } = useGetPointsOfSalesQuery();
  const hasOnlineStores = posList?.some((pos) => pos.type === 'ONLINE');
  const { checkPermissions } = useHasPermissions();

  const navItems: NavItemProps[] = [];

  if (checkPermissions(['DASHBOARD_VIEW'])) {
    navItems.push({
      to: ROUTES.dashboard,
      label: 'Dashboard',
      icon: IconDashboard,
    });
  }

  if (hasOnlineStores && checkPermissions(['ORDERS_VIEW'])) {
    navItems.push({
      to: ROUTES.orders.root,
      label: 'Orders',
      icon: IconOrders,
    });
  }

  if (
    checkPermissions(['APPLICATIONS_VIEW']) ||
    checkPermissions(['TRANSACTIONS_VIEW'])
  ) {
    navItems.push({
      to: pathname.startsWith(ROUTES.transactions.root)
        ? pathname
        : ROUTES.transactions.root,
      label: 'Reports',
      icon: IconReports,
    });
  }

  return navItems;
};
